import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ReactDOM from 'react-dom/client';
import './utils/axiosAuth'; // installs global axios JWT interceptor (must load first)
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AddressProvider } from './components/context/AddressContext';
import { OrdersProvider } from './components/context/OrdersContext';
import { SettingsProvider } from './components/context/SettingsContext';
import { ReportTypeProvider } from './components/context/ReportTypeContext';
import { PromoCodeProvider } from './components/context/PromoCodeContext';
import { CartProvider } from './components/context/CartContext';
import { WishlistProvider } from './components/context/WishlistContext';
import { ShippingMethodProvider } from './components/context/ShippingMethodContext';
import {BlogProvider} from './components/context/BlogContext';
import { ContactProvider } from './components/context/ContactContext';
import {PromoCodeCheckProvider} from './components/context/PromoCodeCheckContext';
import {PromoProvider} from './components/context/PromoContext';
import {ToastProvider } from './components/context/ToastContext';
import {CustomerReviewProvider} from './components/context/CustomerReviewContext';
import {ReturnProvider } from './components/context/ReturnContext';
import {OrderCancelProvider} from './components/context/OrderCancelContext';
import {PromotionalModalProvider} from './components/context/PromotionalModalContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <HelmetProvider>
    <AddressProvider>
      <OrdersProvider>
        <SettingsProvider>
          <ReportTypeProvider>
            <PromoCodeProvider>
              <CartProvider>
                <WishlistProvider>
                  <ShippingMethodProvider>
                    <BlogProvider>
                      <ContactProvider>
                        <PromoCodeCheckProvider>
                          <PromoProvider>
                            <ToastProvider >
                              <CustomerReviewProvider>
                                <ReturnProvider >
                                  <OrderCancelProvider>
                                        <PromotionalModalProvider>
                                          <App />
                                        </PromotionalModalProvider>
                                  </OrderCancelProvider>
                                </ReturnProvider>
                                </CustomerReviewProvider>
                            </ToastProvider>
                          </PromoProvider>
                        </PromoCodeCheckProvider>
                      </ContactProvider>
                    </BlogProvider>
                  </ShippingMethodProvider>
                </WishlistProvider>
              </CartProvider>
            </PromoCodeProvider>
          </ReportTypeProvider>
        </SettingsProvider>
      </OrdersProvider>
    </AddressProvider>
  </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
